import { Component, Host, h, Prop, State, Watch } from '@stencil/core';
// import { relativeTimeThreshold } from 'moment';
import '../header-component/header-component'
import '../loader-component/loader-component'
import queryString from 'query-string'
// import moment from 'moment';
import { DateTime } from "luxon";

const parsedValues = queryString.parse(window.location.search);
let itemid: any = ""
let listname: any = ""
let webpath: any = ""
if (parsedValues != null) {

  console.log("Item Id:" + parsedValues.newsid)
  console.log("list Name:" + parsedValues.listname)
  listname = parsedValues.listname
  itemid = parsedValues.newsid
  webpath = parsedValues.webpath
  window.document.title = "Announcement"

}


/**
#### Sample screen shot
![image info](https://infonet.nyp.org/webc/PublishingImages/newsitem-component.PNG)

#### Content Type
nypwebc_ct_announcements

Query strings
listname
newsid
webpath

Example -  https://infonet.nyp.org/webc/Pages/NewsItem.aspx?listname=webc_announcements&webpath=/webc&newsid=1

*/



@Component({
  tag: 'newsitem-component',
  styleUrl: 'newsitem-component.css',
  scoped: true
})




export class NewsitemComponent {

  /**
   *Required - Unique ID.
   */
  @Prop() componentid: string = "comp-id";


  /**
  *Required - if header attribute is true
  */
  @Prop() sectiontitle: string = "Section Title";

  /**
  *Required - if header attribute is true
  */
  @Prop() titleiconurl: string = "";

  /**
    *Optional - To show/hide header - default is true
    */
  @Prop() header: boolean = true;

  /**
 *Optional - vertical scroll bar
 */
  @Prop() verticalscroll: boolean = false;

  /**
 *Optional - vertical scroll bar height
 */
  @Prop() verticalscrollheight: number = 200;


  /**
*Optional - header background color
*/
  @Prop() headerbgcolor: string = "white"

  /**
  *Optional -header text color
  */
  @Prop() headertextcolor: string = "black"
  /**
  *Optional -header border bottom css
  */
  @Prop() headerborderbottom: string = "1px solid #CE2127"

  /**
  *Optional -include image to the body
  */
  @Prop() includeimage: boolean = true

  @State() isLoading: boolean = true
  @State() items: any = {}

  componentDidLoad() {

    // const siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl;
    let siteUrl: string = "";
    if ((window as any)._spPageContextInfo != null) {
      siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl 
    }
    else {
      let domain = new URL(window.location.href)
      siteUrl = domain.origin 
    }


    
    return fetch(siteUrl + webpath + "/_api/web/lists/getbytitle('" + listname + "')/items('" + itemid + "')?$select=ID,Title,nypwebc_Body,nypwebc_ImageUrl,nypwebc_PostedDate", { headers: { "Accept": "application/json; odata=verbose" } })
      .then(response => response.json())
      .then(data => {
        this.items = data.d;
        this.isLoading = false;
      });
  }

  getContents = () => {

    const contentsArray = []
    var string = this.items.nypwebc_Body;
    var parser = new DOMParser();
    var domNode = parser.parseFromString(string, "text/html");
    const img = domNode.querySelectorAll("img");

    for (let i = 0; i < img.length; i++) {
      img[i].classList.add("sc-newsitem-component", "img-fluid", "rounded");
    }

    // let postedDate = moment(this.items.nypwebc_PostedDate).format("MMMM DD YYYY, h:mm:ss A")
    let postedDate = DateTime.fromISO(this.items.nypwebc_PostedDate).toLocaleString(DateTime.DATETIME_MED)
    contentsArray.push(
      <div key={this.items.ID} >
        <p style={{ fontSize: "25px", marginLeft: "20px", marginTop: "20px" }}> {this.items.Title} </p>
        <p style={{ marginLeft: "20px", marginTop: "10px" }}> {postedDate} </p>

        {/* <a href={this.items.nypwebc_Url}  >
          <img id="about-image" src={this.items.nypwebc_ImageUrl} class="img-fluid rounded  mx-auto d-block  float-md-start" alt={this.items.Title} />
        </a> */}
        {this.includeimage ?
        <img id="about-image" src={this.items.nypwebc_ImageUrl} class="img-fluid rounded  mx-auto d-block  float-md-start" alt={this.items.Title} />
        :null}

        {/* 
  { bodyexist ? */}

        <p > <div class="raw-html-style" style={{paddingLeft:"20px"}} innerHTML={domNode.body.innerHTML} /> </p>
        {/* : */}
        <div></div>
        {/* } */}
      </div>
    )

    return contentsArray
  }

  render() {
    let style = {}
    let styleWithHeader = {}
    let parentstyle = {}
    if (this.verticalscroll) {
      style = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
      }
      styleWithHeader = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
      }

      parentstyle = {
        minHeight: (this.verticalscrollheight + 20) + "px",
        backgroundColor: "white",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        padding: "10px"
      }
    }
    else {
      style = {
      }
      parentstyle = {
        backgroundColor: "white",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        padding: "10px"
      }
    }


    return (
      this.isLoading ?
        <loader-component /> :
        this.header && this.items ?
          <div >
            <header-component sectiontitle={this.sectiontitle} titleiconurl={this.titleiconurl} headerbgcolor={this.headerbgcolor} headertextcolor={this.headertextcolor} headerborderbottom={this.headerborderbottom} />
            <div class="row gx-0" style={parentstyle} >
              <div style={styleWithHeader}>
                {this.getContents()}
              </div>
            </div>
          </div>
          :
          <div class="row gx-0" style={parentstyle} >
            <div style={style}>
              {this.getContents()}
            </div>
          </div>

    )


  }

}
